// extracted by mini-css-extract-plugin
export default {"shadowed":"BaseLayout_shadowed__7GkRG","dark":"BaseLayout_dark__0zPdd","light":"BaseLayout_light__wX+jF"};